import React, { lazy, Suspense, useEffect, useState } from "react";
import { getApiCallHostPath } from "../../utils/apiCallFunction";
import { SAML_LOGIN_URL } from "../../Routes/Routes";
import { APP_COGNITO } from "../../Constants/Constants";
const isCognitoLogin = APP_COGNITO === "true";

const CognitoComponent = isCognitoLogin ? lazy(() => import("./ExternalService/Cognito")) : null;

const LoginWidgetSso = (domainData) => {
  const [MicrosoftAuth, setMicrosoftAuth] = useState(null);

  useEffect(() => {
    if (domainData?.sso_microsoft) {
      import("./ExternalService/Microsoft").then((module) => {
        setMicrosoftAuth(() => module.default);
      });
    }
  }, [domainData?.sso_microsoft]);

  const handleSamlRoute = () => {
    window.location.href = `${getApiCallHostPath()}${SAML_LOGIN_URL}`;
  };

  return (
    <div className="login_outer_container">
      <div className="login_inner_container">
        <div className="login_field">
          <div className="microsoft_auth_container">
            <button onClick={handleSamlRoute} className="microsoft_auth_signin">
              <img src={require("../../Images/microsoft_logo.png")} alt="img" width={"20px"} height={"20px"} />
              <span>Login with SSO</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWidgetSso;
